function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { api } from '@rd-web-markets/shared/dist/services/service';
import { useCallback } from 'react';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch } from 'react-redux';
const changeSetsService = {
  update: change_set => api.update("/change_sets/".concat(change_set.id), {
    change_set
  }),
  create: function (objectId, objectType, review_type, assigned_to_id) {
    let send_email = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let internal_review_type = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    let checklist_answers = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    const body = {
      change_set: {
        object_id: objectId,
        object_type: objectType,
        review_type: review_type,
        assigned_to_id: assigned_to_id,
        send_email: send_email
      }
    };
    if (internal_review_type) {
      body.internal_review_type = internal_review_type;
    }
    if (checklist_answers && checklist_answers.length > 0) {
      body.checklist_answers_attributes = checklist_answers;
    }
    return api.create('/change_sets', body);
  },
  createForClient: function (objectId, objectType, review_type) {
    let startReviewWithSendingEmail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    const body = {
      change_set: {
        send_email: startReviewWithSendingEmail,
        object_id: objectId,
        object_type: objectType,
        review_type: review_type
      }
    };
    return api.create('/change_sets', body);
  },
  useCreateChangeSet: (onChangeSetAction, setLoading) => {
    const dispatch = useDispatch();
    return async function (object, object_type, review_type, assigned_to_id, send_email) {
      let internal_review_type = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      let checklist_answers = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
      setLoading && setLoading(true);
      try {
        await changeSetsService.create(object.id, object_type, review_type, assigned_to_id, send_email, internal_review_type, checklist_answers);
        onChangeSetAction();
      } catch (error) {
        dispatch(handleError(error));
      } finally {
        setLoading && setLoading(false);
      }
    };
  },
  useCreateChangeSetForClient: (onChangeSetAction, setLoading, handleToaster) => {
    const dispatch = useDispatch();
    return async (object, object_type, review_type, startReviewWithSendingEmail, setModalShow) => {
      setLoading && setLoading(true);
      try {
        await changeSetsService.createForClient(object.id, object_type, review_type, startReviewWithSendingEmail);
        setModalShow(false);
        startReviewWithSendingEmail && handleToaster('Email Sent!');
      } catch (error) {
        dispatch(handleError(error));
      } finally {
        onChangeSetAction();
        setLoading && setLoading(false);
      }
    };
  },
  useFinalizeChangeSet: (onChangeSetAction, setLoading) => {
    return useErrorHandling(useCallback(async object => {
      setLoading && setLoading(true);
      await changeSetsService.update(_objectSpread(_objectSpread({}, object.active_change_set), {}, {
        finalized_at: new Date().toISOString()
      }));
      onChangeSetAction();
      setLoading && setLoading(false);
    }, [onChangeSetAction, setLoading]));
  },
  useApproveChangeSet: (onChangeSetAction, setLoading) => {
    const dispatch = useDispatch();
    return async object => {
      setLoading && setLoading(true);
      try {
        await changeSetsService.update(_objectSpread(_objectSpread({}, object.active_change_set), {}, {
          approved_at: new Date().toISOString()
        }));
      } catch (error) {
        dispatch(handleError(error));
      } finally {
        onChangeSetAction();
        setLoading && setLoading(false);
      }
    };
  },
  useRejectChangeSet: (onChangeSetAction, setLoading) => {
    const dispatch = useDispatch();
    return async object => {
      setLoading && setLoading(true);
      try {
        await changeSetsService.update(_objectSpread(_objectSpread({}, object.active_change_set), {}, {
          rejected_at: new Date().toISOString()
        }));
      } catch (error) {
        dispatch(handleError(error));
      } finally {
        onChangeSetAction();
        setLoading && setLoading(false);
      }
    };
  }
};
export default changeSetsService;